<template>
  <div>
    <div class="submit_success">

      <div class="submit_success_image">
        <img :src="successIcon"/>
      </div>

      <h2 class="submit_success_header">{{ $t(`${pagei18nKey}.header`) }}</h2>

      <h3 class="submit_success_text">{{ $t(`${pagei18nKey}.text`) }}</h3>

      <h3 class="submit_success_text">{{ $t(`${pagei18nKey}.refNumber`) }}<br><b>{{ bookingReference }}</b></h3>
      
      <h3 class="submit_success_text">{{ $t(`${pagei18nKey}.emailSoon`) }}</h3>
    </div>
    <p v-if="isKiosk && timeInSecondsUntilScreensaver" class="submit_success_countdown"
    >{{ $t(`${pagei18nKey}.pageWillCloseTitle`) }} <strong>{{this.timeInSecondsUntilScreensaver}}</strong> {{ $t(`${pagei18nKey}.pageWillCloseSeconds`) }}</p>
  </div>
</template>

<script>
import {ButtonTypes} from '@/components/app-button'
import AppSettings from '@/app-settings.json'

export default {
  name: 'SubmitSuccessView',
  data () {
    return {
      pagei18nKey: 'message.submitSuccess',
      buttonType: ButtonTypes.PRIMARY,
      buttonText: 'message.submitSuccess.buttonText',
      successIcon: '/static/theme/img/success-icon.png',
      bookingReference: this.$store.getters.submittedClaimId,
      isKiosk: !!AppSettings.kioskSettings,
      timeInSecondsUntilScreensaver: null
    }
  },
  computed: {
    timeWhenScreensaver: {
      /**
       * Gets  datetime object when to expect screensaver to appear
       */
      get () {
        // data not stored, return null
        if (!this.$store.getters.timeWhenScreensaver) {
          return null
        }
        // all ok, get it from store
        return this.$store.getters.timeWhenScreensaver
      }
    }
  },
  mounted () {
    if (this.isKiosk) {
      this.countdownIntervalFunction = setInterval(() => {
        if (!this.timeWhenScreensaver) {
          // exit
          return
        }
        // + 1 to start displaying max and then close form when 0 appears,
        // /1000 to convert to full seconds
        this.timeInSecondsUntilScreensaver = 1 + parseInt((this.timeWhenScreensaver - new Date()) / 1000)
      }, 500)
    }
  },
  destroyed () {
    if (this.countdownIntervalFunction) {
      clearInterval(this.countdownIntervalFunction)
    }
  },
  methods: {
    onButtonClick: function () {
      this.$router.push('/')
    }
  }
}
</script>


<style lang="scss" scoped>
  @import "../assets/sass/main.scss";

  .submit_success {
    @extend %app_form_container;
    text-align: center;
  }

  .submit_success_button {
    max-width: none;
    padding: $dims-spacing-small 0;
    margin: $dims-spacing-large $dims-horizontal-gutter;
  }

  .submit_success_image {
    img {
      height: $dims-success-icon-height;
      width: $dims-success-icon-width;
    }
  }

  .submit_success_header {
    width: 100%;
    @extend %title_section;
    padding: $dims-horizontal-gutter;
  }

  .submit_success_text {
    padding: 10px 0;
  }

  .submit_success_countdown {
    text-align: center;
  }
</style>

